export default "__VITE_ASSET__Bg$L0BMF__"